import React from "react";
import style from "./ContaDepositoStyle";

var accountInfos = [
  {
    bankName: "Banco Cora",
    beneficiaryName: "Golden Brasil Minérios",
    beneficiaryValue: "35.535.777/0001-35",
    pixType: "CNPJ",
    pixValue: "35535777000135",
    agency: "—",
    accountNumber: "—",
  },
];

export default function ContaDeposito() {
  const copyLink = (linkItem) => {
    const link = linkItem;
    const tempInput = document.createElement("input");
    tempInput.value = link;
    document.body.appendChild(tempInput);
    tempInput.select();
    try {
      const successful = document.execCommand("copy");
      const msg = successful
        ? "Chave pix copiada!"
        : "Falha ao copiar a chave pix.";
      alert(msg);
    } catch (err) {
      console.error("Erro ao copiar a chave pix: ", err);
      alert("Erro ao copiar a chave pix.");
    }
    document.body.removeChild(tempInput);
  };

  return (
    <>
      <div style={style.container}>
        <div style={style.containerBackFilter}></div>
        <div style={style.content}>
          <div style={style.aiaiai}>
            <div style={style.aiaiaiTitleBox}>
              <span style={style.aiaiaiTitle}>Contas Para Depósito</span>
              <span style={style.aiaiaiSubTitle}>Golden Brasil</span>
            </div>
            <img style={style.aiaiaiImage} src="./logo-golden.png" />
          </div>
          <div style={style.boxes}>
            {accountInfos &&
              accountInfos.map((item, key) => (
                <>
                  <div key={key} style={style.box}>
                    <div style={style.boxFirstContent}>
                      <span style={style.boxTitle}>{item.bankName}</span>

                      <div style={style.beneficiaryBox}>
                        <span style={style.beneficiaryBoxTitle}>
                          Beneficiário
                        </span>
                        <span style={style.benediciaryBoxName}>
                          {item.beneficiaryName}
                        </span>
                        <span style={style.benediciaryBoxCnpj}>
                          {item.beneficiaryValue}
                        </span>
                      </div>

                      <div style={style.accountInfo}>
                        <div style={style.accountInfoBox}>
                          <span style={style.accountInfoBoxValue}>
                            <span style={style.accountInfoBoxName}>
                              Pix ({item.pixType}):{" "}
                            </span>
                            <span style={{ textDecoration: "underline" }}>
                              {item.pixValue}
                            </span>
                          </span>
                        </div>

                        <div style={style.accountInfoBox}>
                          <span style={style.accountInfoBoxValue}>
                            <span style={style.accountInfoBoxName}>
                              Agência:{" "}
                            </span>
                            <span style={{ textDecoration: "underline" }}>
                              {item.agency}
                            </span>
                          </span>
                        </div>

                        <div style={style.accountInfoBox}>
                          <span style={style.accountInfoBoxValue}>
                            <span style={style.accountInfoBoxName}>
                              Conta:{" "}
                            </span>
                            <span style={{ textDecoration: "underline" }}>
                              {item.accountNumber}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        copyLink(item.pixValue);
                      }}
                      style={style.copyButton}
                    >
                      Copiar Chave PIX
                    </div>
                  </div>
                </>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}
